<!--
  - Copyright (c) 2017 Ytica.com a.s. - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited
  - Proprietary and confidential
  -
  -->

<template>
    <v-app :class="isTalkdeskUser ? 'talkdesk-bar' : ''">
      <main v-if="authenticated">
        <v-container fluid grid-list-sm ma-0 pa-0>
          <v-layout id="headerWrapper" row>
            <v-flex xs12 pa-0>
              <v-navigation-drawer
                clipped
                absolute
                v-model="drawer"
                disable-resize-watcher
                disable-route-watcher
              >
                <v-list>
                  <v-list-tile v-if="$identity.hasPermission('coaching.view')" @click="drawer = !drawer" :to="{ name: 'agents', params: { account_id: user.account_id }}" ripple>
                    <v-list-tile-title>Agents</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile v-if="$identity.hasPermission('dashboards.view')" @click="drawer = !drawer" :to="{ name: 'dashboards', params: { account_id: user.account_id }}" ripple>
                    <v-list-tile-title>Dashboards</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile v-if="$identity.hasPermission('dashboards.analyze')" @click="drawer = !drawer" :to="{ name: 'analyze', params: { account_id: user.account_id }}" ripple>
                    <v-list-tile-title>Analyze</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile v-if="$identity.hasPermission('assessment.manage')" @click="drawer = !drawer" :to="{ name: 'assessments', params: { account_id: user.account_id }}" ripple>
                    <v-list-tile-title>Assessments</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile v-if="$identity.hasPermission('phrases.view')" @click="drawer = !drawer" :to="{ name: 'speechSearches', params: { account_id: user.account_id }}" ripple>
                    <v-list-tile-title>Speech Searches</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile v-if="$identity.hasPermission('inspections.view')" @click="drawer = !drawer" :to="{ name: 'inspections', params: { account_id: user.account_id }}" ripple>
                    <v-list-tile-title>Inspections</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile v-if="$identity.hasPermission('text.topics:view', ':')" @click="drawer = !drawer" :to="{ name: 'topics', params: { account_id: user.account_id }}" ripple>
                    <v-list-tile-title>Topics</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-navigation-drawer>
              <v-toolbar dense>
                <v-toolbar-title>
                  <v-menu v-if="user.accounts.length > 1" open-on-hover content-class="accounts-dropdown" max-height="70%" left offset-y>
                    <img class="white" :src="logoUrl" slot="activator">
                    <v-list id="switch-account-menu">
                      <v-list-tile v-for="account in user.accounts" :key="account.id" @click="switchAccount(account.id)">
                        <v-list-tile-title>
                          <v-icon color="secondary" :class="(account.id === user.account_id) ? 'mr-2' : 'mr-2 hidden-icon'">fa-arrow-right</v-icon>{{ account.description }}
                        </v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                  <img class="white" :src="logoUrl" v-else>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-side-icon class="hidden-md-and-up" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
                <v-tabs :scrollable="false" class="hidden-sm-and-down">
                    <v-tab v-if="$identity.hasPermission('coaching.view')" :to="{ name: 'agents', params: { account_id: user.account_id }}" ripple>Agents</v-tab>
                    <v-tab v-if="$identity.hasPermission('dashboards.view')" :to="{ name: 'dashboards', params: { account_id: user.account_id }}" ripple>Dashboards</v-tab>
                    <v-tab v-if="$identity.hasPermission('dashboards.analyze')" :to="{ name: 'analyze', params: { account_id: user.account_id }}" ripple>Analyze</v-tab>
                    <v-tab v-if="$identity.hasPermission('assessment.manage')" :to="{ name: 'assessments', params: { account_id: user.account_id }}" class="ml-3" ripple>Assessments</v-tab>
                    <v-tab v-if="$identity.hasPermission('phrases.view')" :to="{ name: 'speechSearches', params: { account_id: user.account_id }}" ripple>Speech Searches</v-tab>
                    <v-tab v-if="$identity.hasPermission('inspections.view')" :to="{ name: 'inspections', params: { account_id: user.account_id }}" ripple>Inspections</v-tab>
                    <v-tab v-if="$identity.hasPermission('text.topics:view', ':')" :to="{ name: 'topics', params: { account_id: user.account_id }}" ripple>Topics</v-tab>
                    <v-tabs-slider color="grey darken-3"></v-tabs-slider>
                </v-tabs>
                <v-menu open-on-hover offset-y left nudge-left="1">
                  <v-btn small flat slot="activator">{{ user.name }}</v-btn>
                  <v-list dense>
                    <!--<v-list-tile href="#">-->
                      <!--<v-list-tile-title><v-icon>lock_open</v-icon> Change Password</v-list-tile-title>-->
                    <!--</v-list-tile>-->
                    <v-list-tile @click.stop="logout()">
                      <v-list-tile-content>
                        <v-list-tile-title><v-icon>exit_to_app</v-icon> Log Out</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-toolbar>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 fill-height pt-0 pb-0>
              <v-content>
                <v-layout row wrap align-center pt-5 v-if="loading" class="fill-height">
                  <v-flex d-flex xs12 justify-center fill-height mt-5>
                    <y-loader :size="80" />
                  </v-flex>
                </v-layout>
                <router-view v-if="!loading" :key="user.account_id" :childPath="childPath" :account_id="user.account_id">
                  <v-container fluid></v-container>
                </router-view>
              </v-content>
            </v-flex>
          </v-layout>
        </v-container>
      </main>
    </v-app>
</template>

<script>
import { YLoader } from '@ytica/vuetify-theme'
import console from './logger.js'

export default {
  name: 'App',
  components: {
    YLoader
  },
  data () {
    return {
      logoUrl: '/static/images/Y_64px.png',
      drawer: false,
      loading: false,
      authenticated: false,
      content_height: 100,
      intercom_visible: false,
      childPath: false
    }
  },
  computed: {
    isYticaUser () {
      if (this.$identity.user) {
        return this.$identity.user.email.search('ytica.com') !== -1
      } else {
        return false
      }
    },
    isTalkdeskUser () {
      return (this.$identity.talkdesk_user === 'true')
    },
    user () {
      const user = this.$identity.user
      if (user.accounts.length > 1) {
        user.accounts.sort((a, b) => {
          const nameA = a.description.toUpperCase() // ignore upper and lowercase
          const nameB = b.description.toUpperCase() // ignore upper and lowercase
          if (nameA < nameB) {
            return -1
          }
          if (nameA > nameB) {
            return 1
          }
          // names must be equal
          return 0
        })
      }
      return user
    },
    allowAgents () {
      return this.$identity.hasPermission('coaching.view')
    },
    allowDashboards () {
      return this.$identity.hasPermission('dashboards.view')
    },
    allowAnalyze () {
      return this.$identity.hasPermission('dashboards.analyze')
    },
    allowAssessments () {
      return this.$identity.hasPermission('assessment.manage')
    },
    allowSpeechSearches () {
      return this.$identity.hasPermission('phrases.view')
    },
    allowInspections () {
      return this.$identity.hasPermission('inspections.view')
    },
    allowTopics () {
      return this.$identity.hasPermission('text.topics:view', ':')
    }
  },
  watch: {
    $route (to, from) {
      console.log('route: ', to)
      // remove childPath if tab was changed
      if (to.name !== from.name) {
        this.childPath = false
      }
      // this.toggleIntercom()
    },
    '$identity.isLoggedIn': async function (newValue, oldValue) {
      console.log('watcher login: ', newValue, oldValue)
      if (newValue === false) {
        setTimeout(() => {
          this.$router.replace({name: 'login'})
        }, 3000)
      }
    }

  },
  created: async function () {
    this.getTalkdeskUser()
    if (this.isTalkdeskUser) {
      document.addEventListener('DOMContentLoaded', function () {
        // eslint-disable-next-line
        TalkdeskConnect.init({theme: 'dark'});
      })
    } else {
      this.logoUrl = 'https://s3.amazonaws.com/ytica-brand/twilio/twilio-mark-red-64.png'
      // favicon
      let link = document.querySelector("link[rel*='icon']") || document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = 'https://s3.amazonaws.com/ytica-brand/twilio/twilio-mark-red.ico'
      document.getElementsByTagName('head')[0].appendChild(link)
    }
    console.log('route: ', this.$route)
    await this.checkAuthentication()
    // check account_id
    if (this.user) {
      if (!this.$route.params['account_id']) {
        this.$router.replace({name: 'dashboards', params: {account_id: this.user.account_id}})
      } else if (this.$route.params['account_id'] !== this.user.account_id) {
        await this.switchAccount(this.$route.params['account_id'])
      }
      this.authenticated = true
      window.addEventListener('message', this.handleApplicationMessages, false)
      // boot intercom
      // this.$intercom.boot({
      //   email: this.user.email
      // })
      // this.toggleIntercom()
    }
    this.childPath = this.$route.params['childPath']
    console.log('child: ', this.$route.params['childPath'])
    console.log('App created')
  },
  methods: {
    checkAuthentication: async function () {
      try {
        console.log('checkAuthentication start..')

        if (this.$route.query.access_token) {
          try {
            console.log('access_token', this.$route.query.access_token)

            let params = {
              access_token: this.$route.query.access_token
            }
            if (this.$route.query.account_id) {
              params.account_id = this.$route.query.account_id
            }

            let data = await this.$identity.loginAuth(params)
            console.log('loginAuth finish.', data)
          } catch (e) {
            console.log('loginAuth error.', e)
          }
        } else {
          // TODO: in the future ask parent app here
        }

        console.info('$identity.authenticate()')
        await this.$identity.authenticate()
        console.info('You are authenticated')

        await this.$identity.userInfo()
        console.log('user Info readed')
      } catch (e) {
        console.log('authenticate catch', e)
        this.error = 'Could not authenticate: ' + (e.message || e)
        this.$router.replace({name: 'login'})
      } finally {
        let filtered = Object.assign({}, this.$route.query)
        delete filtered['access_token']
        delete filtered['gd_project_id']
        delete filtered['account_id']
        this.$router.replace({path: this.$route.path, query: filtered})
      }
    },
    toggleIntercom () {
      if (!document.getElementById('intercom-container')) {
        console.log('intercom not found')
        return
      }
      if (this.$route.name === 'agents' && this.intercom_visible) {
        console.log('hide intercom')
        document.getElementById('intercom-container').style.display = 'none'
        this.intercom_visible = false
      } else if (!this.intercom_visible) {
        console.log('show intercom')
        document.getElementById('intercom-container').style.display = 'block'
        this.intercom_visible = true
      }
    },
    switchAccount: async function (accountId) {
      this.loading = true
      this.$identity.switchAccount(accountId).then((r) => {
        this.$nextTick(() => {
          this.$identity.userInfo().then(() => {
            // this.$router.go(0)
            // this.reloadRoute(this.$route.fullPath)
            this.childPath = this.$route.params['childPath'] || false
            this.$router.push(this.$route.path.replace(this.$route.params['account_id'], this.user.account_id))
            this.loading = false
            console.log('Switch account finish OK.', this.$identity.user.account_id)
          })
        })
      }).catch((e) => {
        // this.error = 'Could not switch account: ' + e.message
        console.log('Could not switch account')
        // redirect to SignIn
        // this.$router.push({name: 'SignIn', query: self.$route.query})
      })
    },
    getTalkdeskUser: function () {
      if (this.$route.query.hide_td_header) {
        window.localStorage.setItem('talkdesk_user', false)
        this.$identity.talkdesk_user = false
      } else {
        this.$identity.talkdesk_user = window.localStorage.getItem('talkdesk_user')
      }
      console.log('talkdesk', this.$identity.talkdesk_user)
    },
    reloadRoute: function (path) {
      // force to reload components
      this.$router.replace('#')
      this.$router.replace(path)
    },
    logout: async function () {
      this.$router.replace({name: 'logout'})
    },
    handleApplicationMessages (evt) {
      let message

      // only from Ytica subdomain
      if (!evt.origin.match(/https:\/\/[^\s]+\.ytica\.(com|io)\/?$/gi)) {
        console.log('Only Ytica domain messages are acceptable')
        return
      }

      console.log(evt)

      message = evt.data

      switch (message.type) {
        // case 'Intercom':
        //   if (message.name === 'trackEvent') {
        //     if (typeof Intercom !== 'undefined') {
        //       if (message.data.hasOwnProperty('metadata')) {
        //         this.$intercom('trackEvent', message.data.eventName, message.data.metadata)
        //       } else {
        //         this.$intercom('trackEvent', message.data.eventName)
        //       }
        //     }
        //   }
        //   break
        case 'route':
          if (message.name === 'updateRoute') {
            console.log('updateRoute: ', message.data.fragment)
            let childPath = this.$route.params['childPath']
            if (childPath) {
              childPath = childPath.replace(/^\/+/g, '')
            }
            this.$router.replace(this.$route.path.replace('/' + childPath, '') + message.data.fragment)
          }
          break
        default:
          break
      }
    }
  }
}
</script>

<style lang="scss">
// @import "../node_modules/@ytica/vuetify-theme/dist/main.css";
@import "../node_modules/@ytica/vuetify-theme/dist/main.css";

html, body {
  height: 100%;
  position: relative;
  min-height: 100%;
  overflow: hidden;
}
#app {
  margin-top: 0;

  height: auto !important;
  height: 100%;
  overflow: hidden;
  position: fixed;
  width: 100%;

  &.talkdesk-bar {
    padding-top: 32px;
  }
  #switch-account-menu {
    .fa {
      font-size: 16px;
      vertical-align: inherit;
    }
    .hidden-icon {
      visibility: hidden;
    }
  }
  .v-toolbar {
    height: 32px !important;
    border-top: none;
    .v-toolbar__content {
      height: 32px !important;
      padding: 0;
    }
    img {
      width: 32px;
    }
    .v-btn {
      text-transform: none;
    }
  }
  .v-toolbar__title {
    height: 32px;
    width: 32px;
    overflow: visible;
    margin-left: 0 !important;
  }
  .v-tabs__container {
    height: 32px;
    .v-tabs__item {
      //text-transform: none;
    }
    .v-tabs:not(.v-tabs--grow):not(.v-tabs--mobile) .v-tabs__item {
      padding: 0 12px;
    }
  }
  .v-toolbar__content {
    .v-btn {
      height: 30px;
      background-color: transparent;
    }
  }
  .accounts-dropdown {
    // overflow-y: auto;
    left: 2px !important;
  }

  .v-tabs__slider {
    background-color: #1976D2 !important;
    border-color: #1976D2 !important;
  }

}

</style>



// WEBPACK FOOTER //
// src/App.vue